import { Adslot } from '../modules/adslot-controller/adslot.js';
import { CENTER_ADS } from './center-ads.js';
import { CLS } from './cls.js';
import { HEIGHT_ANIMATION_CHANGE } from './height-animation-change.js';
import { INTERSTITIAL } from './interstitial.js';
import { LAZYLOAD_SLOT } from './lazyload.js';
import { LOADING_SPINNER } from './loading-spinner.js';
import { MARK_HULL_AS_RESPONDED } from './mark-hull-as-responded.js';
import { MARK_HULL_AS_UNFILLED } from './mark-hull-as-unfilled.js';
import { PIN_TO_BOTTOM } from './pin-to-bottom.js';
import { REMOVE_SLOT_CONTAINER } from './remove-slot-container.js';
import { SCROLL_IN_CONTAINER } from './scroll-in-container.js';
import { HIDE_AD_LABEL } from './hide-ad-label.js';
import { ENABLE_AD_LABEL } from './enable-ad-label.js';
import { STICKY_NODE2 } from './sticky-node2.js';
import { HIDE_SLOT_CONTAINER } from './hide-slot-container.js';

export const IDENTIFIER: unique symbol = Symbol('IDENTIFIER');

export type EffectCleanupFunction = () => void;
export type EffectFunction = {
    (adSlot: Adslot): EffectCleanupFunction;
    [IDENTIFIER]?: string;
}

export const SlotEffects = {
    HEIGHT_ANIMATION_CHANGE,
    HIDE_SLOT_CONTAINER,
    HIDE_AD_LABEL,
    ENABLE_AD_LABEL,
    LAZYLOAD_SLOT,
    CENTER_ADS,
    CLS,
    LOADING_SPINNER,
    MARK_HULL_AS_RESPONDED,
    MARK_HULL_AS_UNFILLED,
    REMOVE_SLOT_CONTAINER,
    STICKY_NODE2,
    PIN_TO_BOTTOM,
    INTERSTITIAL,
    SCROLL_IN_CONTAINER,
};
